import { ActionMenuButton } from "@apex/component-library";
import { Menu, MenuList, Portal } from "@chakra-ui/react";

import { CallDetailResultFromAPI, EventType, Status } from "../../types";
import AddNote from "./AddNote";
import CloseCallMenuItem from "./CloseMarginCallOrAlert";
import ModifyCallMenuItem from "./ModifyCall";

export interface ActionMenuProps {
  value: CallDetailResultFromAPI;
}

export const ActionMenu = ({ value }: ActionMenuProps) => {
  const { status, eventType, eventId, account } = value;
  const isCall = eventType === EventType.Call;
  const isStatusOpen = status && status === Status.Open;

  return (
    <Menu>
      <ActionMenuButton data-testid="action-menu-button" tabIndex={0} />
      <Portal>
        <MenuList>
          <AddNote eventId={eventId} account={account} />
          {isCall && isStatusOpen && <ModifyCallMenuItem record={value} />}
          {isStatusOpen && (
            <CloseCallMenuItem
              account={account}
              eventId={eventId}
              isCall={isCall}
            />
          )}
        </MenuList>
      </Portal>
    </Menu>
  );
};
